import React from "react";
import { connect } from "react-redux";
import Select from "react-dropdown-select";
import "../Forms/css/register.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import axios from "axios";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

const token = localStorage.getItem('authToken');

class EditAttribute extends React.Component {
  constructor(props) {
    super(props);
    this.state = {   
      name: '',
     
    
      submissionStatus: null,
      id: null,
   
     
    };
  }
  
  async componentDidMount() {
    const { match } = this.props;
    if (match && match.params && match.params.id) {
      const { id } = match.params;
      this.setState({ id });
      await this.fetchData(id);
    } else {
      console.error("No match or id found in props");
    }
  }

  fetchData = async (id) => {
    console.log("Fetch data called with id:", id);
    try {
      const response = await axios.get(`https://brand.aasmo.in/api/superadmin/attribute/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const userData = response?.data;
      console.log("Fetch data response:", userData);
      if (userData) {
        this.setState({
          name: userData?.name || '',
        
        
         
        });
      } else {
        console.error("No user data found");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };



  handleSubmit = async (e) => {
    e.preventDefault();
    const { id } = this.props.match.params;

    // Create a JSON object from the state
    const jsonData = { ...this.state };

    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`, // Ensure token is correctly set
            }
        };

        const response = await axios.put(`https://brand.aasmo.in/api/superadmin/attribute/${id}`, jsonData, config);

        console.log('Response:', response);

        if (response && response.status === 200) {  // Changed to 200 for successful update
            this.setState({ submissionStatus: 'success' });
            console.log('Form submitted successfully');
            setTimeout(() => {
                this.props.history.push('/list-attribute');
            }, 2000);
        } else {
            console.log('Unexpected response:', response);
        }
    } catch (error) {
        console.error('Error submitting form:', error);

        if (error.response) {
            const { status, data } = error.response;
            if (status === 400) {
                console.error('Bad request error:', data);
            } else if (status === 401) {
                console.error('Unauthorized error, please log in again.');
            } else {
                console.error('Error response:', error.response);
            }
        } else {
            console.error('Network or other error:', error);
        }
    }
};

  

  render() {
    const { submissionStatus, image, identityImage, imageFile, identityImageFile } = this.state;
    return (
      <div className="col-md-12">
        <form onSubmit={this.handleSubmit}>
          <div className="card">
            <div className="header">
              <h2>Edit Attribute</h2>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label>Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={this.state.name}
                      onChange={this.handleChange}
                      placeholder="First Name"
                    />
                  </div>
              
           
                  {submissionStatus === 'success' && (
                <div className="alert alert-success" role="alert">
                  Form submitted successfully!
                </div>
              )}
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  this.setState({ submit: true });
                  this.handleSubmit(e);
                }}
              >
                Submit
              </button>
                </div>
              
              </div>
            </div>
         
         
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default withRouter(EditAttribute);
